import AboutHeader from "./AboutHeader/AboutHeader";
import AboutMe from "./AboutMe/AboutMe";
import AboutPage from "./AboutPage/AboutPage";
import Projects from "./Projects/Projects";
import WorkExperience from "./WorkExperience/WorkExperience";
import Skills from "./Skills/Skills";
import SkillContainer from "./SkillContainer/SkillContainer"
import SkillIndicator from "./SkillIndicator/SkillIndicator";

export {AboutHeader, AboutMe, AboutPage, Projects, WorkExperience, Skills, SkillIndicator, SkillContainer}